import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'

export const Route = createFileRoute('/_authenticated/')({
  beforeLoad: () => {
    const { getHomePath } = useAuthStore.getState()
    throw redirect({ to: getHomePath() })
  },
})
